export default __webpack_public_path__ + "static/media/send-chat.6ea0eb44.svg";